import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { imageSrc } from "../lib/images";

export const ImageCarousel = ({ images, alt, id = "product-carousel" }) => {
  const [index, setIndex] = useState(0);
  const list = images.length ? images : [""];
  useEffect(() => { setIndex(0); }, [images]);
  const go = step => setIndex(i => (i + step + list.length) % list.length);
  return <div className="carousel" data-testid={id}>
    <div className="carousel-stage">
      {list.map((url, i) => <img key={url || i} src={imageSrc(url)} alt={`${alt} ${i + 1}`} className={i === index ? "active" : ""} data-testid={`${id}-image-${i}`} loading={i === 0 ? "eager" : "lazy"}/>)}
      {list.length > 1 && <>
        <button type="button" className="carousel-arrow prev" aria-label="Gambar sebelumnya" data-testid={`${id}-prev`} onClick={() => go(-1)}><ChevronLeft size={20}/></button>
        <button type="button" className="carousel-arrow next" aria-label="Gambar berikutnya" data-testid={`${id}-next`} onClick={() => go(1)}><ChevronRight size={20}/></button>
        <span className="carousel-counter" data-testid={`${id}-counter`}>{index + 1} / {list.length}</span>
      </>}
    </div>
    {list.length > 1 && <div className="carousel-thumbs" role="tablist" aria-label="Pilih gambar">
      {list.map((url, i) => <button type="button" key={url || i} role="tab" aria-selected={i === index} className={i === index ? "active" : ""} data-testid={`${id}-thumb-${i}`} onClick={() => setIndex(i)}><img src={imageSrc(url)} alt=""/></button>)}
    </div>}
  </div>;
};
